import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import './BaseChip.css';
import './ChipContent.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var content = _7a468({defaultClassName:'_uhh9yl1-3-12-1',variantClassNames:{size:{'default':'_uhh9yl2-3-12-1',condensed:'_uhh9yl3-3-12-1'}},defaultVariants:{},compoundVariants:[]});
export var prefix = '_uhh9yl4-3-12-1';